import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';

import { useI18n } from '@/providers/i18n';
import Marquee from '@/ui/Marquee';

import styles from './Footer.module.css';

const MARQUEE_ITEMS = [
  'MOCT 07 — IN FREQUENCY',
  'YEREVAN',
  'HAYFILM CLUSTER',
  'AYRARAT CINEMA',
  'EST. 2019',
  'STRICTLY 18+',
  'FACE CONTROL',
  'TRANSMISSION ACTIVE',
] as const;

export default function Footer() {
  const { t } = useI18n();
  const year = new Date().getFullYear();
  const [email, setEmail] = useState('');
  const [signed, setSigned] = useState(false);

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    setSigned(true);
    setEmail('');
    window.setTimeout(() => setSigned(false), 2400);
  };

  return (
    <footer className={styles.root}>
      <Marquee speed={90} items={MARQUEE_ITEMS} />
      <div className={styles.grid}>
        <div>
          <span className={`nano ${styles.colLabel}`}>{t('foot.signup')}</span>
          <div className={styles.tagline}>{t('foot.signup.note')}</div>
          <form className={styles.form} onSubmit={onSubmit}>
            <input
              type="email"
              required
              placeholder="EMAIL"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              aria-label="Email address"
            />
            <button type="submit" className={styles.formBtn} aria-label="Subscribe">
              {signed ? '✓' : '→'}
            </button>
          </form>
        </div>

        <div>
          <span className={`nano ${styles.colLabel}`}>INDEX</span>
          <ul className={styles.links}>
            <li><Link to="/events">{t('nav.events')}</Link></li>
            <li><Link to="/artists">{t('nav.artists')}</Link></li>
            <li><Link to="/shop">{t('nav.shop')}</Link></li>
            <li><Link to="/contact">{t('nav.contact')}</Link></li>
          </ul>
        </div>

        <div>
          <span className={`nano ${styles.colLabel}`}>CONTACT</span>
          <ul className={styles.links}>
            <li><a href="mailto:moctpromo@gmail.com">moctpromo@gmail.com</a></li>
            <li>
              <a href="https://instagram.com/moct_yerevan" target="_blank" rel="noreferrer">
                @moct_yerevan
              </a>
            </li>
            <li>
              <a href="https://facebook.com/MOCTyerevan" target="_blank" rel="noreferrer">
                /MOCTyerevan
              </a>
            </li>
            <li>
              <a href="https://ra.co" target="_blank" rel="noreferrer">
                RA / RESIDENT ADVISOR
              </a>
            </li>
          </ul>
        </div>

        <div>
          <span className={`nano ${styles.colLabel}`}>LOCATIONS</span>
          <ul className={styles.links}>
            <li>
              HAYFILM CLUSTER
              <br />
              <span className="fg-dim">ASHTARAK HWY 30</span>
            </li>
            <li>
              AYRARAT CINEMA
              <br />
              <span className="fg-dim">SAYAT-NOVA 40</span>
            </li>
          </ul>
        </div>
      </div>

      <div className={styles.bottom} aria-label="legal">
        <span>© MOCT {year}</span>
        <span>YEREVAN / ARMENIA</span>
        <span>SYSTEM v0.7</span>
        <span>ALL RIGHTS / NO TRESPASS</span>
      </div>
    </footer>
  );
}
